import { ApiRequest } from "src/helpers";
import { API_END_POINTS } from "src/constants";

export function createLeadRecommenationsApi(data) {
  return ApiRequest.fetchAdmin({
    method: "post",
    url: API_END_POINTS.CREATE_LEAD_RECOMMENDATIONS,
    data,
  }).then((response) => response.data);
}